import axios from "axios";
import { authenticatedApiConfig, generateURL } from "./BaseApiService";
import { AIPartnerDto } from "healthex-common/aipartner.dtos";
export class AIPartnerAdminService {
    constructor(authenticationProvider, environment) {
        this.authenticationProvider = authenticationProvider;
        this.environment = environment;
    }
    async listPartners() {
        const response = await axios.get(generateURL(this.environment.API_BASE_URL, "/admin/ai-partners"), await authenticatedApiConfig(this.authenticationProvider));
        return {
            total: response.data.total,
            results: response.data.results.map((item) => new AIPartnerDto(item)),
        };
    }
    async getPartner(id) {
        const response = await axios.get(generateURL(this.environment.API_BASE_URL, "/admin/ai-partners/:id", { id }), await authenticatedApiConfig(this.authenticationProvider));
        return response.data === "" || response.data === null ? null : new AIPartnerDto(response.data);
    }
    async createPartner(input) {
        const response = await axios.post(generateURL(this.environment.API_BASE_URL, "/admin/ai-partners"), input, await authenticatedApiConfig(this.authenticationProvider));
        return new AIPartnerDto(response.data);
    }
    async updatePartner(id, input) {
        const response = await axios.put(generateURL(this.environment.API_BASE_URL, "/admin/ai-partners/:id", { id }), input, await authenticatedApiConfig(this.authenticationProvider));
        return new AIPartnerDto(response.data);
    }
    async deletePartner(id) {
        await axios.delete(generateURL(this.environment.API_BASE_URL, "/admin/ai-partners/:id", { id }), await authenticatedApiConfig(this.authenticationProvider));
    }
    async refreshCache() {
        await axios.post(generateURL(this.environment.API_BASE_URL, "/admin/ai-partners/refresh-cache"), {}, await authenticatedApiConfig(this.authenticationProvider));
    }
}
